if (!customElements.get("product-pack")) {
  class ProductPack extends HTMLElement {
    constructor() {
      super();
      this.packs = this.querySelectorAll(".pack__wrapper component-pack");
      this.addToCartButton = this.querySelector("#product-pack-submit");
      this.addToCartPrice = this.addToCartButton.querySelector("#buttonPrice");
      this.form = this.querySelector("form");
      this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector("cart-drawer")) this.submitButton.setAttribute("aria-haspopup", "dialog");
      document.body.classList.add('packPresentOnPage');

      this.selects = this.querySelectorAll('.pack__select');
      this.selects.forEach(select => {
        select.addEventListener('change', () => { this.updateThumbnail(select) })
      })
    }

    connectedCallback() {
      this.listenEvents();
    }

    updateThumbnail(select) {
      const selectedOption = select.querySelector('option:checked');
      const thumbnail = this.querySelector(`#${select.dataset.thumbnailId}`);
      
      const quantity = +this.querySelector(".pack__selected").dataset.unitQuantity / +this.querySelector(".pack__selected").dataset.quantity;
      console.log(this.querySelector(".pack__selected").dataset.unitQuantity);
      console.log(this.querySelector(".pack__selected").dataset.quantity);
      
      const productId = +selectedOption.value;
      const object = window.thumbnails.filter(obj => obj.product_id === productId && obj.quantity === quantity);
      thumbnail.src = object[0].image;
    }

    listenEvents() {
      this.onPackSelection();
      let array = [];

      document.addEventListener("component-pack:array-initialized", (event) => {        
        array = event.detail.array;
      });

      this.form.addEventListener("submit", (event) => {
        this.addToCart(event, array);
      });
    }

    resetSelectedPack() {
      document.querySelectorAll(".pack__wrapper .pack").forEach((pack) => {
        pack.classList.remove("pack__selected");
      });
    }

    onPackSelection() {
      this.packs.forEach((pack) => {
        pack.addEventListener("click", () => {
          this.resetSelectedPack();
          pack.classList.add("pack__selected");

          const newPrice = pack.querySelector(".prix").textContent;
          const newUnitQuantity = +pack.dataset.unitQuantity;
          const newUnitPrice = new Intl.NumberFormat("fr", { style: "currency", currency: "EUR" }).format(+pack.dataset.prix / newUnitQuantity);

          this.addToCartPrice.textContent = newPrice;
          this.querySelector('#unitQuantity').textContent = newUnitQuantity;
          this.querySelector('#unitPrice').textContent = newUnitPrice;
        });
      });
    }

    addToCart(event, array) {
      event.preventDefault();

      function mergeItems(items) {
        const map = items.reduce((acc, {id, quantity}) => {
          const q = Number(quantity);
          if (!acc[id]) acc[id] = q;
          else acc[id] += q;
          return acc;
        }, {});
        return Object.entries(map).map(([id, total]) => ({
          id,
          quantity: String(total)
        }));
      }
      
      
      let itemsGrouped = this.buildItems(array);
      let items = mergeItems(itemsGrouped);
      console.log(items);

      if (this.submitButton.getAttribute("aria-disabled") === "true") return;

      this.submitButton.setAttribute("aria-disabled", true);

      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append(
          "sections",
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      for (let i = 0; i < items.length; i++) {
        config.body.set(`items[${i}][id]`, items[i].id);
        config.body.set(`items[${i}][quantity]`, items[i].quantity);
      }

      fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify({ items })
        }).then(res => {
          if (!res.ok) {
            return res.text().then(text => { throw new Error(text); });
          }
          return res.json();
        })
        .then((response) => {
          if (response.status) {
            const soldOutMessage =
              this.submitButton.querySelector(".sold-out-message");
            if (!soldOutMessage) return;

            this.submitButton.setAttribute("aria-disabled", true);
            this.submitButton.querySelector("span").classList.add("hidden");
            soldOutMessage.classList.remove("hidden");
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location.href = '/checkout';
            return;
          }

          this.cart.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.cart && this.cart.classList.contains("is-empty"))
            this.cart.classList.remove("is-empty");
          if (!this.error) this.submitButton.removeAttribute("aria-disabled");
        });
    }
    
    buildItems(array) {
      const selectedComponentPack = this.querySelector(".pack__selected");
      const selects = selectedComponentPack.querySelectorAll('select');
      let items = [];

      if (selects.length > 0) {
        selects.forEach(select => {
          const selectedOption = select.querySelector('option:checked');
          const id = selectedOption.dataset.id;
          const quantity = selectedOption.dataset.quantity;
          items.push({ id: id, quantity: quantity });
        });
      } else {
        const quantity = selectedComponentPack.dataset.quantity;
        window.productsToAdd.forEach(item => {
          items.push({ id: item.variant_id, quantity: quantity });
        });
      }
      
      return items;
    }
  }
  customElements.define("product-pack", ProductPack);
}